/** Identifiant court, suffisant pour distinguer les blocs d'une même page. */
export function uid() {
    return Math.random().toString(36).slice(2, 10);
}
export function slugify(input) {
    return input
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 80);
}
export const BLOCK_LABELS = {
    hero: 'Bannière (hero)',
    text: 'Texte',
    split: 'Image + texte',
    features: 'Atouts / services',
    news: 'Actualités',
    carousel: 'Carrousel',
    pricing: 'Tarifs',
    cta: "Appel à l'action",
    form: 'Formulaire',
    contact: 'Coordonnées',
    logos: 'Partenaires / logos',
    team: 'Membres / équipe',
    registration: 'Inscription en ligne',
    groups: 'Groupes d’entraînement',
    planning: 'Planning des cours',
    sitemap: 'Plan du site (automatique)',
    headline: 'La une',
    section: 'Rubrique',
    mostread: 'Les plus lus',
    newsletter: 'Lettre d’information',
};
/** Blocs propres au journal : inutiles (et déroutants) sur un site vitrine. */
export const MAGAZINE_BLOCKS = ['headline', 'section', 'mostread'];
export const ARTICLE_STATUS_LABELS = {
    draft: 'Brouillon',
    review: 'À relire',
    published: 'Publié',
    archived: 'Archivé',
};
export const ARTICLE_NODE_LABELS = {
    p: 'Paragraphe',
    h2: 'Intertitre',
    quote: 'Citation',
    image: 'Image',
    list: 'Liste',
    gallery: 'Galerie photos',
};
export function field(label, type, required = false) {
    return { id: uid(), label, type, required, placeholder: '', options: '' };
}
export function newBlock(type) {
    const id = uid();
    switch (type) {
        case 'hero':
            return {
                id,
                type,
                eyebrow: '',
                title: 'Un titre qui accroche',
                subtitle: 'Une phrase qui dit en quelques mots ce que vous proposez.',
                image: null,
                primary: { label: 'Découvrir', href: '#' },
                secondary: null,
                align: 'left',
                height: 'medium',
                overlay: 40,
            };
        case 'text':
            return { id, type, title: 'Titre de section', body: 'Votre texte ici.', align: 'left' };
        case 'split':
            return {
                id,
                type,
                eyebrow: '',
                title: 'Titre de section',
                body: 'Décrivez ici votre activité.',
                image: null,
                imageSide: 'right',
                cta: null,
            };
        case 'features':
            return {
                id,
                type,
                title: 'Nos atouts',
                intro: '',
                columns: 3,
                items: [
                    { icon: '★', title: 'Atout 1', text: 'Description courte.', image: null },
                    { icon: '◆', title: 'Atout 2', text: 'Description courte.', image: null },
                    { icon: '●', title: 'Atout 3', text: 'Description courte.', image: null },
                ],
            };
        case 'news':
            return { id, type, title: 'Actualités', category: '', count: 3, layout: 'grid' };
        case 'carousel':
            return {
                id,
                type,
                title: '',
                slides: [
                    { image: null, title: 'Diapositive 1', caption: '', href: '' },
                    { image: null, title: 'Diapositive 2', caption: '', href: '' },
                ],
                autoplay: true,
                interval: 5,
            };
        case 'pricing':
            return {
                id,
                type,
                title: 'Tarifs',
                intro: '',
                plans: [
                    {
                        name: 'Essentiel',
                        price: '29 €',
                        period: '/mois',
                        features: 'Avantage 1\nAvantage 2',
                        highlight: false,
                        cta: null,
                    },
                    {
                        name: 'Premium',
                        price: '49 €',
                        period: '/mois',
                        features: 'Avantage 1\nAvantage 2\nAvantage 3',
                        highlight: true,
                        cta: null,
                    },
                ],
            };
        case 'cta':
            return {
                id,
                type,
                title: 'Prêt à commencer ?',
                text: '',
                cta: { label: 'Nous contacter', href: '/contact' },
                tone: 'primary',
            };
        case 'form':
            return {
                id,
                type,
                title: 'Contactez-nous',
                intro: '',
                fields: [
                    field('Nom', 'text', true),
                    field('E-mail', 'email', true),
                    field('Message', 'textarea', true),
                ],
                submitLabel: 'Envoyer',
                successMessage: 'Merci, votre message a bien été envoyé.',
                notifyEmail: '',
            };
        case 'contact':
            return { id, type, title: 'Nous trouver', address: '', phone: '', email: '', hours: '' };
        case 'logos':
            return {
                id,
                type,
                title: 'Nos partenaires',
                intro: '',
                items: [{ name: 'Partenaire', image: null, href: '' }],
            };
        case 'team':
            return {
                id,
                type,
                title: 'Les membres de l’association',
                intro: '',
                members: [
                    { name: 'Prénom Nom', role: 'Président·e', photo: null, text: '' },
                    { name: 'Prénom Nom', role: 'Trésorier·ère', photo: null, text: '' },
                    { name: 'Prénom Nom', role: 'Secrétaire', photo: null, text: '' },
                ],
            };
        case 'groups':
            return {
                id,
                type,
                title: 'Nos groupes',
                intro: '',
                columns: 3,
                style: 'tiles',
                showSchedule: true,
            };
        case 'sitemap':
            return { id, type, title: 'Plan du site', intro: '' };
        case 'planning':
            return {
                id,
                type,
                title: 'Planning des cours',
                intro: 'Les séances de la semaine, groupe par groupe. Les annulations y sont signalées.',
            };
        case 'registration':
            return {
                id,
                type,
                title: 'Inscription en ligne',
                intro: '',
                fields: registrationFields(),
                submitLabel: 'Envoyer mon inscription',
                successMessage: 'Merci ! Votre demande d’inscription est enregistrée. Nous revenons vers vous pour la confirmer.',
                closedMessage: 'Les inscriptions en ligne sont fermées pour le moment. Pour toute question, merci de nous contacter.',
                notifyEmail: '',
                contacts: {
                    enabled: true,
                    min: 1,
                    title: 'Contacts',
                    intro: 'Parents, tuteur ou personnes à prévenir : ajoutez au moins un contact.',
                },
            };
        case 'headline':
            return {
                id,
                type,
                layout: 'slider',
                source: 'featured',
                count: 5,
                showFeed: true,
                feedTitle: 'Le fil',
                interval: 7,
            };
        case 'section':
            return {
                id,
                type,
                category: '',
                title: '',
                layout: 'tiles',
                count: 4,
                moreLabel: 'Voir tout',
            };
        case 'mostread':
            return { id, type, title: 'Les plus lus', count: 5, days: 7 };
        case 'newsletter':
            return {
                id,
                type,
                title: 'La lettre d’information',
                text: 'Chaque semaine, l’essentiel de l’actualité directement dans votre boîte aux lettres.',
                buttonLabel: 'Je m’inscris',
                successMessage: 'Merci ! Confirmez votre inscription grâce au lien que nous venons de vous envoyer.',
                askName: false,
                tone: 'primary',
            };
    }
}
/** Champs d'un bulletin d'adhésion classique, point de départ du bloc. */
/** Bloc « Contacts » du bulletin, quand il n'a pas encore été réglé. */
export const DEFAULT_REGISTRATION_CONTACTS = {
    enabled: true,
    min: 1,
    title: 'Contacts',
    intro: 'Parents, tuteur ou personnes à prévenir : ajoutez au moins un contact.',
};
/** Liens d'un contact avec l'adhérent. */
export const CONTACT_RELATIONS = {
    pere: 'Père',
    mere: 'Mère',
    oncle: 'Oncle',
    tante: 'Tante',
    tuteur: 'Tuteur / tutrice',
    responsable: 'Responsable',
    autre: 'Autre',
};
/** « Père », ou la précision saisie pour « Autre ». */
export const contactRelationLabel = (c) => c.relation === 'autre' && c.relationOther.trim()
    ? c.relationOther.trim()
    : CONTACT_RELATIONS[c.relation];
export function registrationFields() {
    return [
        field('Le nageur', 'section'),
        field('Nom', 'text', true),
        field('Prénom', 'text', true),
        field('Date de naissance', 'date', true),
        { ...field('Sexe', 'select', true), options: 'Féminin\nMasculin' },
        field('Adresse', 'text', true),
        field('Téléphone', 'tel', true),
        field('E-mail', 'email', true),
        field('Inscription', 'section'),
        {
            ...field('Type d’inscription', 'select', true),
            options: 'Nouvelle inscription\nRenouvellement',
        },
        { ...field('Groupe souhaité', 'select'), options: '' },
        field('Documents et validation', 'section'),
        field('Certificat médical', 'file'),
        field('Message', 'textarea'),
        field('J’accepte le règlement intérieur', 'checkbox', true),
    ];
}
export function newArticleNode(type) {
    const id = uid();
    switch (type) {
        case 'p':
            return { id, type, text: '' };
        case 'h2':
            return { id, type, text: '' };
        case 'quote':
            return { id, type, text: '', cite: '' };
        case 'image':
            return { id, type, image: null, caption: '' };
        case 'list':
            return { id, type, ordered: false, items: '' };
        case 'gallery':
            return { id, type, images: [], caption: '' };
    }
}
const p = (text) => ({ id: uid(), type: 'p', text });
const h2 = (text) => ({ id: uid(), type: 'h2', text });
const LOREM = 'Le texte définitif viendra ici. Ce paragraphe sert à juger de la mise en page : longueur des lignes, interlignage, rythme entre les intertitres et les images.';
function sampleBody() {
    return [
        p(LOREM),
        p('Un second paragraphe, avec un passage en **gras**, un autre en *italique* et un [lien](https://eduqor.org).'),
        h2('Un intertitre pour relancer la lecture'),
        p(LOREM),
        {
            id: uid(),
            type: 'quote',
            text: 'Une citation forte, mise en exergue au milieu du texte.',
            cite: 'Une source',
        },
        p(LOREM),
    ];
}
/**
 * Site vitrine — club de sport pour enfants (référence : leptitclub.fr).
 *
 * ⭐ Site en UNE page : toutes les rubriques sont des blocs de l'accueil, et
 * le menu pointe sur leurs ancres (`/#tarifs` = bloc d'identifiant `tarifs`).
 * Un clic dans le menu fait défiler jusqu'au bloc au lieu d'ouvrir une page.
 *
 * Les illustrations par défaut (`/templates/site/…`) sont générées par
 * apps/web/scripts/generate-template-art.mjs ; l'éditeur les remplace par ses
 * photos depuis la médiathèque.
 */
function siteTemplate(name) {
    const art = (file, alt) => ({ url: `/templates/site/${file}`, alt });
    return {
        settings: {
            tagline: 'Le sport, le jeu et la joie de grandir ensemble',
            logo: null,
            theme: { primary: '#0b1f3a', accent: '#2563eb', font: 'grotesk', radius: 'round' },
            nav: [
                { label: 'Activités', href: '/#activites' },
                { label: 'Le club', href: '/#club' },
                { label: 'Tarifs', href: '/#tarifs' },
                { label: 'Actualités', href: '/#actualites' },
                { label: 'Contact', href: '/#contact' },
            ],
            headerCta: { label: 'Séance d’essai', href: '/#inscription' },
            footer: {
                text: `${name} — des activités sportives encadrées pour les enfants de 18 mois à 12 ans.`,
                columns: [
                    {
                        title: 'Le club',
                        links: [
                            { label: 'Activités', href: '/#activites' },
                            { label: 'L’équipe', href: '/#club' },
                            { label: 'Tarifs', href: '/#tarifs' },
                        ],
                    },
                    {
                        title: 'Infos',
                        links: [
                            { label: 'Actualités', href: '/#actualites' },
                            { label: 'Inscription', href: '/#inscription' },
                            { label: 'Nous trouver', href: '/#contact' },
                        ],
                    },
                ],
                social: [
                    { network: 'instagram', href: 'https://instagram.com' },
                    { network: 'facebook', href: 'https://facebook.com' },
                ],
            },
            seoDescription: `${name} : gym d’éveil, multisport, stages vacances et anniversaires sportifs pour les enfants.`,
        },
        categories: [
            { slug: 'vie-du-club', name: 'Vie du club', color: '#2563eb' },
            { slug: 'stages', name: 'Stages', color: '#0ea5e9' },
        ],
        pages: [
            {
                slug: 'accueil',
                title: 'Accueil',
                isHome: true,
                showInNav: false,
                blocks: [
                    {
                        id: 'accueil',
                        type: 'hero',
                        eyebrow: 'Club de sport pour enfants · 18 mois – 12 ans',
                        title: 'Bouger, jouer, grandir ensemble.',
                        subtitle: 'Gym d’éveil, multisport, stages vacances et anniversaires : des activités encadrées par des éducateurs diplômés, pour que chaque enfant prenne confiance en s’amusant.',
                        image: art('hero-enfants.svg', 'Groupe d’enfants qui sautent de joie en plein air'),
                        primary: { label: 'Réserver une séance d’essai', href: '/#inscription' },
                        secondary: { label: 'Découvrir les activités', href: '/#activites' },
                        align: 'left',
                        height: 'full',
                        overlay: 55,
                    },
                    {
                        id: 'activites',
                        type: 'features',
                        title: 'Des activités pour chaque âge',
                        intro: 'Des séances adaptées au développement de l’enfant, en petits groupes, dans une salle pensée pour eux.',
                        columns: 4,
                        items: [
                            {
                                icon: '🤸',
                                title: 'Gym d’éveil',
                                text: 'Dès 18 mois : parcours moteurs, équilibre et coordination, avec ou sans les parents.',
                                image: art('activite-eveil.svg', 'Enfants sur des tapis et blocs de mousse'),
                            },
                            {
                                icon: '⚽',
                                title: 'Multisport',
                                text: 'De 4 à 12 ans : foot, basket, athlétisme, jeux d’opposition… une discipline par cycle.',
                                image: art('activite-multisport.svg', 'Enfants qui jouent au ballon'),
                            },
                            {
                                icon: '☀️',
                                title: 'Stages vacances',
                                text: 'À la journée ou à la semaine, pendant toutes les vacances scolaires.',
                                image: art('activite-stages.svg', 'Groupe d’enfants en plein air'),
                            },
                            {
                                icon: '🎂',
                                title: 'Anniversaires',
                                text: 'Deux heures de jeux sportifs animés, goûter compris. Votre enfant est la star !',
                                image: art('activite-anniversaire.svg', 'Enfants, ballons et gâteau'),
                            },
                        ],
                    },
                    {
                        id: 'club',
                        type: 'split',
                        eyebrow: 'Le club',
                        title: 'Une équipe passionnée et bienveillante',
                        body: 'Nos éducateurs sont **diplômés d’État** et formés à la petite enfance. Chaque séance suit un projet pédagogique : progresser par le jeu, à son rythme, dans un cadre sûr.\n\nGroupes de 12 enfants maximum, salle de 400 m² équipée, accueil personnalisé de chaque famille.',
                        image: art('club-equipe.svg', 'Un éducateur sportif entouré d’enfants'),
                        imageSide: 'right',
                        cta: { label: 'Rencontrer l’équipe', href: '/#inscription' },
                    },
                    {
                        id: 'equipe',
                        type: 'team',
                        title: 'L’équipe',
                        intro: 'Des éducateurs diplômés, à l’écoute de chaque enfant.',
                        members: [
                            { name: 'Prénom Nom', role: 'Responsable du club', photo: null, text: '' },
                            { name: 'Prénom Nom', role: 'Éducateur·rice sportif·ve', photo: null, text: '' },
                            { name: 'Prénom Nom', role: 'Éducateur·rice sportif·ve', photo: null, text: '' },
                        ],
                    },
                    {
                        id: 'galerie',
                        type: 'carousel',
                        title: 'Le club en images',
                        slides: [
                            {
                                image: art('galerie-salle.svg', 'La salle de gym d’éveil'),
                                title: 'La salle d’éveil',
                                caption: 'Tapis, modules et parcours',
                                href: '',
                            },
                            {
                                image: art('galerie-terrain.svg', 'Le terrain multisport'),
                                title: 'Le terrain multisport',
                                caption: 'Un sport différent à chaque cycle',
                                href: '',
                            },
                            {
                                image: art('galerie-fete.svg', 'Un anniversaire au club'),
                                title: 'Les anniversaires',
                                caption: 'Le samedi et le dimanche après-midi',
                                href: '',
                            },
                        ],
                        autoplay: true,
                        interval: 5,
                    },
                    {
                        id: 'tarifs',
                        type: 'pricing',
                        title: 'Des formules simples',
                        intro: 'Séance d’essai offerte · Réduction fratrie de 10 %',
                        plans: [
                            {
                                name: 'Séance découverte',
                                price: '0 €',
                                period: 'la 1re séance',
                                features: 'Toutes activités\nSans engagement\nBilan avec l’éducateur',
                                highlight: false,
                                cta: { label: 'Réserver', href: '/#inscription' },
                            },
                            {
                                name: 'Année',
                                price: '29 €',
                                period: '/mois',
                                features: '1 séance par semaine\nHors vacances scolaires\nAssurance incluse',
                                highlight: true,
                                cta: { label: 'Inscrire mon enfant', href: '/#inscription' },
                            },
                            {
                                name: 'Stage vacances',
                                price: '35 €',
                                period: '/jour',
                                features: '9h – 17h, repas tiré du sac\nGoûter fourni\nTarif semaine : 160 €',
                                highlight: false,
                                cta: { label: 'Voir les dates', href: '/#actualites' },
                            },
                        ],
                    },
                    {
                        id: 'actualites',
                        type: 'news',
                        title: 'Actualités du club',
                        category: '',
                        count: 3,
                        layout: 'grid',
                    },
                    {
                        id: 'inscription',
                        type: 'form',
                        title: 'Réservez une séance d’essai',
                        intro: 'Remplissez ce formulaire : nous vous rappelons sous 24 h pour choisir le créneau.',
                        fields: [
                            field('Nom et prénom du parent', 'text', true),
                            field('E-mail', 'email', true),
                            field('Téléphone', 'tel', true),
                            field('Prénom et âge de l’enfant', 'text', true),
                            {
                                ...field('Activité souhaitée', 'select', true),
                                options: 'Gym d’éveil\nMultisport\nStage vacances\nAnniversaire',
                            },
                            field('Message', 'textarea'),
                            field('Certificat médical (PDF ou photo)', 'file'),
                            field('J’accepte d’être recontacté(e)', 'checkbox', true),
                        ],
                        submitLabel: 'Envoyer ma demande',
                        successMessage: 'Merci ! Nous vous rappelons très vite pour fixer la séance.',
                        notifyEmail: '',
                    },
                    {
                        id: 'contact',
                        type: 'contact',
                        title: 'Nous trouver',
                        address: '12 rue du Stade\n75000 Paris',
                        phone: '01 23 45 67 89',
                        email: 'contact@exemple.fr',
                        hours: 'Mercredi : 9h – 18h\nSamedi : 9h – 17h\nVacances : 9h – 17h du lundi au vendredi',
                    },
                ],
            },
        ],
        articles: [
            {
                title: 'Les stages de la Toussaint sont ouverts',
                kicker: 'Stages',
                excerpt: 'Multisport, cirque et grands jeux : découvrez le programme des vacances.',
                category: 'stages',
                featured: true,
                cover: art('activite-stages.svg', 'Groupe d’enfants en plein air'),
                body: sampleBody(),
            },
            {
                title: 'Nouveau créneau de gym d’éveil le samedi',
                kicker: 'Vie du club',
                excerpt: 'Un groupe supplémentaire pour les 18 mois – 3 ans, accompagnés d’un parent.',
                category: 'vie-du-club',
                featured: false,
                cover: art('activite-eveil.svg', 'Enfants sur des tapis de gym'),
                body: sampleBody(),
            },
            {
                title: 'Fêtez l’anniversaire de votre enfant au club',
                kicker: 'Anniversaires',
                excerpt: 'Deux heures de jeux animés par nos éducateurs, goûter compris.',
                category: 'vie-du-club',
                featured: false,
                cover: art('activite-anniversaire.svg', 'Enfants, ballons et gâteau'),
                body: sampleBody(),
            },
        ],
    };
}
/**
 * Journal en ligne — moderne et épuré (référence de mise en page : la
 * boutique unowhy : grands visuels arrondis, diaporama, tuiles photo,
 * bandeaux défilants). L'accueil est une PAGE DE BLOCS — la une, une section
 * par rubrique, les plus lus, la lettre d'information — que la rédaction
 * recompose depuis le back-office (Pages › À la une).
 *
 * Les visuels d'exemple (`/templates/magazine/…`) sont générés par
 * apps/web/scripts/generate-magazine-art.mjs.
 */
function magazineTemplate(name) {
    const art = (file, alt) => ({ url: `/templates/magazine/${file}`, alt });
    const categories = [
        {
            slug: 'politique',
            name: 'Politique',
            color: '#d62839',
            description: 'Gouvernement, Parlement, collectivités : la vie politique décryptée.',
        },
        {
            slug: 'societe',
            name: 'Société',
            color: '#2563eb',
            description: 'Logement, éducation, santé, travail : ce qui change dans nos vies.',
        },
        {
            slug: 'monde',
            name: 'Monde',
            color: '#0f766e',
            description: 'L’actualité internationale, ses enjeux et ses acteurs.',
        },
        {
            slug: 'culture',
            name: 'Culture',
            color: '#7c3aed',
            description: 'Spectacles, livres, cinéma, expositions : nos coups de cœur.',
        },
        {
            slug: 'sport',
            name: 'Sport',
            color: '#ea580c',
            description: 'Résultats, portraits et coulisses du sport.',
        },
        {
            slug: 'football',
            name: 'Football',
            color: '#ea580c',
            parent: 'sport',
            inNav: false,
            description: 'Championnats, coupes et sélections.',
        },
    ];
    const articles = [
        {
            category: 'politique',
            title: 'Budget : les grandes lignes du projet présenté en Conseil des ministres',
            kicker: 'Décryptage',
            featured: true,
            cover: art('politique-hemicycle.svg', 'L’hémicycle de l’Assemblée nationale'),
        },
        {
            category: 'societe',
            title: 'Logement : dans les grandes villes, la pénurie s’installe durablement',
            kicker: 'Enquête',
            featured: true,
            cover: art('societe-immeubles.svg', 'Façades d’immeubles en centre-ville'),
            access: 'subscribers',
        },
        {
            category: 'monde',
            title: 'Sommet international : un accord a minima sur le climat',
            kicker: 'Diplomatie',
            featured: true,
            cover: art('monde-globe.svg', 'Le globe terrestre'),
        },
        {
            category: 'culture',
            title: 'Le festival d’automne ouvre ses portes avec une programmation audacieuse',
            kicker: 'Spectacle',
            featured: false,
            cover: art('culture-scene.svg', 'Une scène de théâtre sous les projecteurs'),
        },
        {
            category: 'football',
            title: 'Une victoire arrachée dans les dernières minutes',
            kicker: 'Football',
            featured: false,
            cover: art('sport-stade.svg', 'Un stade de football illuminé'),
        },
        {
            category: 'societe',
            title: 'À l’école, le numérique bouscule les habitudes',
            kicker: 'Éducation',
            featured: false,
            cover: art('societe-ecole.svg', 'Une salle de classe'),
        },
        {
            category: 'politique',
            title: 'Collectivités : les maires face à la hausse des coûts',
            kicker: 'Territoires',
            featured: false,
            cover: art('politique-mairie.svg', 'La façade d’une mairie'),
        },
        {
            category: 'culture',
            title: 'Cinq livres à lire cet automne',
            kicker: 'Livres',
            featured: false,
            cover: art('culture-livres.svg', 'Une pile de livres'),
        },
        {
            category: 'monde',
            title: 'Élections : un scrutin sous haute surveillance',
            kicker: 'International',
            featured: false,
            cover: art('monde-urne.svg', 'Une urne électorale'),
        },
        {
            category: 'sport',
            title: 'Cyclisme : le parcours de la grande boucle dévoilé',
            kicker: 'Cyclisme',
            featured: false,
            cover: art('sport-velo.svg', 'Des cyclistes sur une route de montagne'),
        },
        {
            category: 'politique',
            title: 'Assemblée : le texte sur la fin de vie adopté en première lecture',
            kicker: 'Parlement',
            featured: false,
            cover: art('politique-hemicycle.svg', 'L’hémicycle de l’Assemblée nationale'),
        },
        {
            category: 'societe',
            title: 'Transports : la gratuité des bus séduit de plus en plus de villes',
            kicker: 'Mobilités',
            featured: false,
            cover: art('societe-immeubles.svg', 'Une rue en centre-ville'),
        },
        {
            category: 'societe',
            title: 'Santé : les déserts médicaux gagnent du terrain',
            kicker: 'Enquête',
            featured: false,
            cover: art('societe-ecole.svg', 'Une salle de classe'),
            access: 'subscribers',
        },
        {
            category: 'monde',
            title: 'Europe : les Vingt-Sept trouvent un compromis sur l’énergie',
            kicker: 'Europe',
            featured: false,
            cover: art('monde-globe.svg', 'Le globe terrestre'),
        },
        {
            category: 'culture',
            title: 'Cinéma : le documentaire qui a bouleversé le festival',
            kicker: 'Cinéma',
            featured: false,
            cover: art('culture-scene.svg', 'Une salle de spectacle'),
        },
        {
            category: 'football',
            title: 'Coupe nationale : les petits poucets continuent de rêver',
            kicker: 'Football',
            featured: false,
            cover: art('sport-stade.svg', 'Un stade de football illuminé'),
        },
        {
            category: 'sport',
            title: 'Athlétisme : un record national tombe sous la pluie',
            kicker: 'Athlétisme',
            featured: false,
            cover: art('sport-velo.svg', 'Une route de montagne'),
        },
    ].map((a) => ({
        ...a,
        excerpt: 'Le chapô résume l’article en deux ou trois phrases : il donne envie de lire la suite sans tout dévoiler.',
        body: sampleBody(),
    }));
    const section = (category, layout, count = 4) => ({
        id: `rubrique-${category}`,
        type: 'section',
        category,
        title: '',
        layout,
        count,
        moreLabel: 'Voir tout',
    });
    return {
        settings: {
            tagline: 'L’information, sans détour',
            logo: null,
            theme: { primary: '#0d1321', accent: '#d62839', font: 'editorial', radius: 'round' },
            nav: [],
            headerCta: { label: 'S’abonner', href: '/abonnement' },
            footer: {
                text: `${name} — journal en ligne indépendant.`,
                columns: [
                    {
                        title: 'Rubriques',
                        links: categories
                            .filter((c) => !c.parent)
                            .map((c) => ({ label: c.name, href: `/rubrique/${c.slug}` })),
                    },
                    {
                        title: 'Le journal',
                        links: [
                            { label: 'Qui sommes-nous', href: '/a-propos' },
                            { label: 'Contributeurs', href: '/contributeurs' },
                            { label: 'S’abonner', href: '/abonnement' },
                            { label: 'Contact', href: '/contact' },
                        ],
                    },
                ],
                social: [
                    { network: 'x', href: 'https://x.com' },
                    { network: 'facebook', href: 'https://facebook.com' },
                ],
            },
            seoDescription: '',
            paywall: {
                title: 'La suite est réservée aux abonnés',
                text: 'Soutenez une information indépendante : abonnez-vous pour lire tous nos articles, enquêtes et reportages.',
                ctaLabel: 'Je m’abonne',
                ctaHref: '/contact',
            },
        },
        categories,
        pages: [
            {
                slug: 'a-la-une',
                title: 'À la une',
                isHome: true,
                showInNav: false,
                blocks: [
                    {
                        id: 'une',
                        type: 'headline',
                        layout: 'slider',
                        source: 'featured',
                        count: 5,
                        showFeed: true,
                        feedTitle: 'Le fil',
                        interval: 7,
                    },
                    section('politique', 'tiles'),
                    section('societe', 'lead'),
                    {
                        id: 'lettre',
                        type: 'newsletter',
                        title: 'La lettre de la rédaction',
                        text: 'Chaque matin, l’essentiel de l’actualité dans votre boîte aux lettres. Gratuit, sans publicité.',
                        buttonLabel: 'Je m’inscris',
                        successMessage: 'Merci ! Confirmez votre inscription grâce au lien que nous venons de vous envoyer.',
                        askName: false,
                        tone: 'dark',
                    },
                    section('monde', 'row', 6),
                    { id: 'plus-lus', type: 'mostread', title: 'Les plus lus', count: 5, days: 30 },
                    section('culture', 'tiles'),
                    section('sport', 'row', 6),
                ],
            },
            {
                slug: 'a-propos',
                title: 'Qui sommes-nous',
                isHome: false,
                showInNav: false,
                blocks: [
                    {
                        id: uid(),
                        type: 'text',
                        title: 'Qui sommes-nous',
                        body: `${name} est un journal en ligne indépendant.\n\nPrésentez ici la rédaction, sa ligne éditoriale et ses engagements.`,
                        align: 'left',
                    },
                ],
            },
            {
                slug: 'contact',
                title: 'Contact',
                isHome: false,
                showInNav: false,
                blocks: [
                    {
                        id: uid(),
                        type: 'form',
                        title: 'Écrire à la rédaction',
                        intro: 'Une information, un témoignage, un droit de réponse ? Écrivez-nous.',
                        fields: [
                            field('Nom', 'text', true),
                            field('E-mail', 'email', true),
                            {
                                ...field('Objet', 'select', true),
                                options: 'Information\nTémoignage\nDroit de réponse\nAbonnement\nAutre',
                            },
                            field('Message', 'textarea', true),
                            field('Document (facultatif)', 'file'),
                        ],
                        submitLabel: 'Envoyer',
                        successMessage: 'Merci, la rédaction a bien reçu votre message.',
                        notifyEmail: '',
                    },
                ],
            },
        ],
        articles,
    };
}
export function templateFor(kind, name) {
    const t = kind === 'site' ? siteTemplate(name) : magazineTemplate(name);
    // Tous les modèles : les pages légales, aux contenus neutres à compléter.
    return { ...t, pages: [...t.pages, ...legalPages()] };
}
/**
 * Taux de présence (0–100, arrondi) : un retard compte pour une
 * demi-présence ; excusé et absent ne comptent pas. null sans appel.
 */
export function attendanceRate(present, late, called) {
    if (!called)
        return null;
    return Math.round(((present + late / 2) / called) * 100);
}
// ───────────────────────────────────────────────────────── pages légales
/** Adresses des pages légales, liées depuis le pied de page de tous les sites. */
export const LEGAL_SLUGS = ['mentions-legales', 'cgu', 'confidentialite', 'plan-du-site'];
const legalText = (id, title, body) => ({
    id,
    type: 'text',
    title,
    body,
    align: 'left',
});
/**
 * Les quatre pages légales, aux contenus NEUTRES : chaque information propre
 * au site est entre crochets, à remplacer par le responsable du site (Pages).
 * Valables pour tous les modèles (site vitrine, journal).
 */
export function legalPages() {
    return [
        {
            slug: 'mentions-legales',
            title: 'Mentions légales',
            isHome: false,
            showInNav: false,
            blocks: [
                legalText('cadre', '', 'Conformément à la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l’économie numérique (LCEN), voici les informations relatives à l’éditeur et à l’hébergeur du site. **Les mentions entre crochets sont à compléter.**'),
                legalText('editeur', 'Éditeur du site', '**[Nom de la structure]** — [forme juridique : association loi 1901, société, collectivité…]\n\nSiège : [adresse complète]\n\nE-mail : [adresse e-mail de contact] — Téléphone : [numéro]\n\n[Numéro RNA, SIREN ou SIRET]'),
                legalText('directeur', 'Directeur ou directrice de la publication', '[Prénom Nom], [fonction : président·e, gérant·e, directeur·rice…].'),
                legalText('hebergement', 'Hébergement', 'Le site est hébergé par OVH SAS (OVHcloud), 2 rue Kellermann, 59100 Roubaix, France — [www.ovhcloud.com](https://www.ovhcloud.com).\n\nIl est réalisé avec Publiqa, plateforme fournie par **eduqor**.'),
                legalText('propriete', 'Propriété intellectuelle', 'Les textes, photographies, logos et autres contenus du site sont la propriété de [Nom de la structure] ou de leurs auteurs. Toute reproduction, représentation ou diffusion, totale ou partielle, sans autorisation préalable est interdite.\n\nCrédits photographiques : [à compléter].'),
                legalText('contact', 'Contact', 'Pour toute question sur le site : [adresse e-mail de contact].'),
            ],
        },
        {
            slug: 'cgu',
            title: 'Conditions générales d’utilisation',
            isHome: false,
            showInNav: false,
            blocks: [
                legalText('cadre', '', 'Les présentes conditions générales d’utilisation (CGU) encadrent l’accès au site de [Nom de la structure] et son utilisation. En naviguant sur le site, vous les acceptez sans réserve.'),
                legalText('objet', 'Objet du site', 'Le site présente [Nom de la structure] et ses activités. Selon les rubriques, il permet de consulter ses informations et actualités, de la contacter, de s’inscrire en ligne ou de s’abonner à sa lettre d’information.'),
                legalText('acces', 'Accès au site', 'Le site est accessible gratuitement à tout utilisateur disposant d’un accès à internet. L’éditeur s’efforce de le maintenir disponible, mais peut l’interrompre, notamment pour maintenance, sans que sa responsabilité puisse être engagée.'),
                legalText('formulaires', 'Formulaires, inscriptions et comptes', 'Les informations transmises par les formulaires du site (contact, inscription, abonnement) doivent être exactes et à jour. Une inscription en ligne constitue une demande : elle ne devient définitive qu’après validation par [Nom de la structure].\n\nLe traitement des données personnelles est décrit dans la [politique de confidentialité](/confidentialite).'),
                legalText('contenus', 'Contenus et propriété intellectuelle', 'Les contenus du site sont protégés par le droit d’auteur. Leur consultation est réservée à un usage strictement personnel ; toute autre utilisation nécessite l’accord préalable de l’éditeur.'),
                legalText('responsabilite', 'Responsabilité et liens', 'Les informations publiées (horaires, tarifs, plannings, actualités…) sont données à titre indicatif et peuvent évoluer. Le site peut contenir des liens vers d’autres sites, dont l’éditeur ne maîtrise pas le contenu et n’est pas responsable.'),
                legalText('droit', 'Droit applicable', 'Les présentes CGU sont régies par le droit français. Elles peuvent être modifiées à tout moment ; la version en ligne fait foi. Pour toute question : [adresse e-mail de contact].'),
            ],
        },
        {
            slug: 'confidentialite',
            title: 'Politique de confidentialité',
            isHome: false,
            showInNav: false,
            blocks: [
                legalText('cadre', '', '[Nom de la structure] attache une grande importance à la protection de vos données personnelles. Elles sont traitées conformément au règlement général sur la protection des données (RGPD) et à la loi « Informatique et libertés ». **Les mentions entre crochets sont à compléter.**'),
                legalText('responsable', 'Responsable du traitement', '**[Nom de la structure]** — [adresse complète] — [adresse e-mail de contact].'),
                legalText('donnees', 'Données collectées et finalités', 'Selon les services utilisés, peuvent être collectées :\n\n**Formulaire de contact** : nom, adresse e-mail, message et pièce jointe éventuelle — pour répondre à votre demande.\n\n**Inscription en ligne** : identité, coordonnées, personnes à contacter, photo et documents demandés — pour traiter et gérer l’inscription. [Adapter à votre activité.]\n\n**Lettre d’information** : adresse e-mail — pour vous adresser les envois auxquels vous vous êtes abonné.'),
                legalText('base', 'Base légale', 'Les traitements reposent sur votre demande ou votre consentement (contact, lettre d’information), sur l’exécution de l’inscription ou de l’adhésion, et sur l’intérêt légitime de [Nom de la structure] à organiser ses activités.'),
                legalText('destinataires', 'Destinataires', 'Les données sont réservées aux personnes habilitées de [Nom de la structure]. Elles sont hébergées dans l’Union européenne par OVH SAS (OVHcloud), via la plateforme Publiqa (eduqor), pour le compte de [Nom de la structure]. Elles ne sont ni vendues ni cédées à des tiers.'),
                legalText('duree', 'Durée de conservation', 'Messages : [durée, par exemple 1 an]. Données d’inscription ou d’adhésion : [durée, par exemple 3 ans après la fin de l’adhésion]. Lettre d’information : jusqu’à votre désinscription.'),
                legalText('droits', 'Vos droits', 'Vous disposez d’un droit d’accès, de rectification, d’effacement, de limitation, d’opposition et de portabilité de vos données. Pour l’exercer : [adresse e-mail de contact]. Vous pouvez aussi adresser une réclamation à la CNIL ([www.cnil.fr](https://www.cnil.fr)).'),
                legalText('cookies', 'Cookies', 'Le site n’utilise ni cookie publicitaire ni outil de mesure d’audience tiers. Seuls des cookies techniques, indispensables au fonctionnement (connexion à un espace réservé), peuvent être déposés. [À adapter si vous ajoutez un outil de mesure d’audience.]'),
            ],
        },
        {
            slug: 'plan-du-site',
            title: 'Plan du site',
            isHome: false,
            showInNav: false,
            blocks: [{ id: 'plan', type: 'sitemap', title: '', intro: '' }],
        },
    ];
}
//# sourceMappingURL=defaults.js.map